export const selectLanguageData = (state) => state.languageLabelData.languageData;